import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-nav">
      {/* Dark Background with effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark via-dark-secondary to-dark" />
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/background-hero.jpg)',
          opacity: 0.5,
        }}
      />
      <div className="absolute inset-0 lightning-bg opacity-60" />
      <div className="absolute inset-0 particle-bg" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-radial-gold opacity-30 blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gradient-radial-blue opacity-20 blur-3xl" />

      <div className="container-premium relative z-10">
        <div className="flex flex-col items-center text-center">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-6"
          >
            <img
              src="/images/logo.png"
              alt="HashMedora"
              className="mx-auto w-full max-w-[544px] h-auto"
            />
          </motion.div>

          {/* Logo Text */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mb-6"
          >
            <img
              src="/images/logo-text.png"
              alt="HashMedora"
              className="mx-auto w-full max-w-[753px] h-auto"
            />
          </motion.div>

          {/* Slogan - Desktop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="hidden sm:block mb-10"
          >
            <img
              src="/images/logo-slogan.png"
              alt="Powered by Hash. Driven by Trust."
              className="mx-auto w-full max-w-[768px] h-auto"
            />
          </motion.div>

          {/* Slogan - Mobile */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="block sm:hidden mb-10"
          >
            <img
              src="/images/logo-slogan-mobile.png"
              alt="Powered by Hash. Driven by Trust."
              className="mx-auto w-full max-w-[278px] h-auto"
            />
          </motion.div>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="text-gray-400 text-lg max-w-2xl mx-auto mb-10 leading-relaxed"
          >
            Experience the future of decentralized lottery on BSC. Five thrilling games, instant
            real-time payouts, and up to <span className="text-hash-gold font-semibold">10,000x</span>{' '}
            multipliers await.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.0 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <Link
              to="/games"
              className="btn-gold px-10 py-4 rounded-xl text-lg font-bold inline-flex items-center gap-2 hover:shadow-gold-glow-lg transition-all"
            >
              <img src="/images/icon-ticket.svg" alt="" className="w-5 h-5" style={{ filter: 'brightness(0)' }} />
              Play Now
            </Link>
            <Link
              to="/analytics"
              className="btn-blue-outline px-10 py-4 rounded-xl text-lg font-bold inline-flex items-center gap-2"
            >
              <img src="/images/icon-chart-bar.svg" alt="" className="w-5 h-5" />
              View Analytics
            </Link>
          </motion.div>

          {/* Stats preview */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.2 }}
            className="mt-16 pb-4 grid grid-cols-3 gap-8 max-w-lg"
          >
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-hash-gold drop-shadow-[0_0_10px_rgba(238,212,91,0.5)]">4</div>
              <div className="text-gray-500 text-sm mt-1">Games</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-medora-blue drop-shadow-[0_0_10px_rgba(17,172,236,0.5)]">300K</div>
              <div className="text-gray-500 text-sm mt-1">Prize Pool</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-bold text-hash-gold drop-shadow-[0_0_10px_rgba(238,212,91,0.5)]">30%</div>
              <div className="text-gray-500 text-sm mt-1">Win Rate</div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-dark to-transparent" />
    </section>
  );
}

export default HeroSection;
